var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwWarranty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_181_8098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9 16.2L17.6 15.3C17.5 15.3 17.5 15.2 17.5 15.2L16.6 12.9C16.5 12.7 16.3 12.7 16.2 12.9L15.3 15.2C15.3 15.3 15.2 15.3 15.2 15.3L12.9 16.2C12.7 16.3 12.7 16.5 12.9 16.6L15.2 17.5C15.3 17.5 15.3 17.6 15.3 17.6L16.2 19.9C16.3 20.1 16.5 20.1 16.6 19.9L17.5 17.6C17.5 17.5 17.6 17.5 17.6 17.5L19.9 16.6C20 16.5 20 16.3 19.9 16.2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.80001L12.8 4.70001C12.9 4.70001 12.9 4.80001 12.9 4.80001L13.8 7.10001C13.9 7.30001 14.1 7.30001 14.2 7.10001L15 4.80001C15 4.70001 15.1 4.70001 15.1 4.70001L17.4 3.80001C17.6 3.70001 17.6 3.50001 17.4 3.40001L15.1 2.50001C15 2.50001 15 2.40001 15 2.40001L14.1 0.100012C14 -0.0999878 13.8 -0.0999878 13.7 0.100012L13 2.50001C13 2.60001 12.9 2.60001 12.9 2.60001L10.6 3.50001C10.3 3.50001 10.3 3.70001 10.5 3.80001Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2 9.40001L8.3 8.30001L7.2 5.40001C7 4.90001 6.5 4.60001 6 4.60001C5.5 4.60001 5 4.90001 4.8 5.40001L3.7 8.30001L0.8 9.40001C0.3 9.60001 0 10.1 0 10.6C0 11.1 0.3 11.6 0.8 11.8L3.7 12.9L4.8 15.8C5 16.3 5.5 16.6 6 16.6C6.5 16.6 7 16.3 7.2 15.8L8.3 12.9L11.2 11.8C11.7 11.6 12 11.1 12 10.6C12 10.1 11.7 9.60001 11.2 9.40001ZM10.8 10.8L7.4 12L6.2 15.4C6.1 15.6 5.9 15.6 5.8 15.4L4.6 12L1.2 10.8C1.1 10.8 1.1 10.7 1.1 10.6C1.1 10.5 1.1 10.4 1.2 10.4L4.6 9.20001L5.8 5.80001C5.8 5.70001 5.9 5.70001 6 5.70001C6.1 5.70001 6.2 5.70001 6.2 5.80001L7.4 9.20001L10.8 10.4C10.9 10.4 10.9 10.5 10.9 10.6C10.9 10.7 10.9 10.8 10.8 10.8Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_181_8098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwWarranty);
export default __webpack_public_path__ + "static/media/aw-warranty.5ca10cce1fb9e94cda3037489197754e.svg";
export { ForwardRef as ReactComponent };